import defaultImageUrl from '~/assets/img/default-thumbnail.webp'
import type { Image } from '~/types'

export const useDefaultImage = (forceUrl?: string) => {
  const url = computed<string>(() => forceUrl || defaultImageUrl)

  const image = computed<Image>(() => ({
    id: -1,
    src: url.value,
    srcset: url.value,
    alt: '',
    caption: '',
  }))

  return {
    image,
  }
}
